////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const toastSuccess = {
	hydrateToast: (successMsgParams, redirectRequest = '') => ({
		type: ActionsTypes.HYDRATE_TOAST,
		payload: {
			successMsgParams,
			redirectRequest,
		},
	}),
	closeToast: () => ({
		type: ActionsTypes.CLOSE_TOAST,
		payload: {},
	}),
	openNext: () => ({
		type: ActionsTypes.OPEN_NEXT,
		payload: {},
	}),
}

export default toastSuccess
